import { render, staticRenderFns } from "./upPwd.vue?vue&type=template&id=7552944f&scoped=true&"
import script from "./upPwd.vue?vue&type=script&lang=js&"
export * from "./upPwd.vue?vue&type=script&lang=js&"
import style0 from "./upPwd.vue?vue&type=style&index=0&id=7552944f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552944f",
  null
  
)

export default component.exports